import { render, staticRenderFns } from "./TagsSelectHeader.vue?vue&type=template&id=1556d2e9&lang=pug&"
import script from "./TagsSelectHeader.vue?vue&type=script&lang=js&"
export * from "./TagsSelectHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports